import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'textNewLines',
})
export class TextNewLinesPipe implements PipeTransform {
  transform(value: string, args: string[]): any {
    return value? value.replace(/(?:\r\n|\r|\n)/g, '<br />'): value;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/text-new-lines/text-new-lines.ts